import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Loader2, Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { td } from '@/lib/i18n';
import { sendWorkspaceTelegramTest } from '@/services/workspace';
import { sendTelegramTest as sendInternalTelegramTest } from '@/services/internal-setting';
import { errorHandler } from '@/lib/utils';
export function TelegramChatIdTestButton({ chatId, source, size = 'default', variant = 'outline', className, }) {
    const { t } = useTranslation();
    const { mutate, isPending } = useMutation({
        mutationFn: async (id) => {
            return source.kind === 'workspace'
                ? sendWorkspaceTelegramTest({ workspaceId: source.workspaceId, chatId: id })
                : sendInternalTelegramTest({ profile: 'internal', chatId: id });
        },
        onSuccess: (data) => {
            if (data.sent) {
                toast.success(td(t, 'telegram_chat_id_test.success', {
                    defaultValue: 'Test sent — check your Telegram chat.',
                }));
            }
            else {
                toast.error(td(t, 'telegram_chat_id_test.failure', {
                    error: data.error ?? 'unknown error',
                    defaultValue: 'Test failed: {{error}}',
                }));
            }
        },
        onError: errorHandler,
    });
    const trimmed = (chatId ?? '').trim();
    return (<Button type="button" size={size} variant={variant} className={className} disabled={isPending || trimmed === ''} onClick={() => mutate(trimmed)} title={td(t, 'telegram_chat_id_test.title', { defaultValue: 'Send a test message to this chat' })}>
            {isPending ? <Loader2 className="h-3.5 w-3.5 animate-spin"/> : <Send className="h-3.5 w-3.5"/>}
            {td(t, 'telegram_chat_id_test.label', { defaultValue: 'Test' })}
        </Button>);
}
